import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  updateNotificationStatusFailed,
  updateNotificationStatusStart,
  updateNotificationStatusSuccess,
} from "../redux/updateNotiStatus";
import { updateStatusNotificationAPI } from "core/http/service/notification";
import {
  getListNotificationStart,
  resetListNotification,
} from "../redux/getListNoti";
import { resetControlPage } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";

function* updateNotificationStatusWork(action) {
  const { ...payload } = action.payload;
  try {
    const res = yield call(updateStatusNotificationAPI, payload);
    yield put({
      type: updateNotificationStatusSuccess.type,
      payload: res,
    });
    yield put({
      type: resetListNotification.type,
    });
    yield put({
      type: resetControlPage.type,
      payload: "notification",
    });
    yield put({
      type: getListNotificationStart.type,
      payload: { offset: 0, limit: 10, sort: "" },
    });
  } catch (error: any) {
    yield put({
      type: updateNotificationStatusFailed.type,
    });
  }
}

function* watchUpdateNotificationStatus() {
  yield takeLatest(
    updateNotificationStatusStart.type,
    updateNotificationStatusWork
  );
}
export default function* updateNotificationStatusSaga() {
  yield all([watchUpdateNotificationStatus()]);
}
